import React from 'react';
import PropTypes from 'prop-types';
import Heading from "../Heading";
import StarRating from "../StarRating";
import { StarRatingProps } from "../../utils/propTypes";
import Box from "../Box";
import Flex from "../Flex";
import Text from "../Text";
import Tags from "../Tags";
import Divider from "../Divider";
import Hide from "../Hide";

var ArticleCard = function ArticleCard(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    borderRadius: "10px",
    backgroundColor: "white",
    id: props.id
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: ['column-reverse', null, 'row']
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flex: "1",
    p: 6,
    pb: 0
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    flex: "1 0"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "normal"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold",
    fontSize: "xs",
    textTransform: "uppercase"
  }, props.badge), /*#__PURE__*/React.createElement(Heading.h2, {
    fontSize: "xl",
    fontWeight: "normal"
  }, props.title), (props.starRatingProps || props.tags) && /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    flexDirection: "row",
    mb: 6
  }, props.starRatingProps && /*#__PURE__*/React.createElement(StarRating, props.starRatingProps), props.tags && /*#__PURE__*/React.createElement(Tags, {
    ml: props.starRatingProps ? 2 : 0
  }, props.tags.map(function (tag, key) {
    return /*#__PURE__*/React.createElement(Tags.Tag, {
      key: key
    }, tag);
  }))), props.description && /*#__PURE__*/React.createElement(Box, {
    fontSize: "md",
    mb: 6
  }, props.description), props.bodyComponent), props.footerCallToAction && /*#__PURE__*/React.createElement(Flex, {
    flexDirection: 'column',
    mt: [5, null, 'auto']
  }, /*#__PURE__*/React.createElement(Hide, {
    md: true,
    lg: true
  }, /*#__PURE__*/React.createElement(Divider, {
    width: "100%"
  })), /*#__PURE__*/React.createElement(Box, {
    mt: [5, null, 3]
  }, props.footerCallToAction)))), props.imageComponent), props.footerComponent && /*#__PURE__*/React.createElement(Box, {
    p: 6
  }, props.footerComponent)), props.annotation);
};

ArticleCard.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  description: PropTypes.string,
  badge: PropTypes.string.isRequired,
  starRatingProps: PropTypes.shape(StarRatingProps),
  tags: PropTypes.arrayOf(PropTypes.string.isRequired),
  annotation: PropTypes.node,
  footerCallToAction: PropTypes.node,
  footerComponent: PropTypes.node,
  imageComponent: PropTypes.node,
  bodyComponent: PropTypes.node
};
export default ArticleCard;